module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "محمد-بن-محمد-منير-محروقة"
    }
  }, [_c('h1', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("محمد بن محمد منير محروقة")])]), _vm._v(" "), _c('blockquote', [_c('div', {
    staticClass: "figure"
  }, [_c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "1.73128in",
      "height": "1.84721in"
    },
    attrs: {
      "alt": "",
      "src": "media/file1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("A person in a suit Description automatically generated")])])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em"
    }
  }, [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("محمد بن محمد منير محروقة مِن مواليد دمشق 1956 بسوريا، تعلَّم بمدارسها، وحصل على البكالوريوس بالعلوم الفيزيائيَّة والكيميائيَّة في جامعة دمشق عام 1979- 1980.")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em"
    }
  }, [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v(" عملَ أستاذًا للفيزياء والكيمياء وبمُختبرات التحليل الإشعاعي بالوقاية الإشعاعيَّة في بعض الدول العربية.")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em"
    }
  }, [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("ساهَم بإنشاء مختبرات مطيافية جاما لمراقبة تسرُّب الإشعاع للغذاء والبيئة.")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em"
    }
  }, [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v(" عضو في كثير منَ اللِّجان المتخصِّصة بالوقاية الإشعاعية وفِرَق العمل لوَضعِ اللوائح التنظيمية للإشعاع المؤيّن والإشعاع البيئي.")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em"
    }
  }, [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("لدَيه خبرة في استعراض الدراسات البيئية لتقييم الآثار البيئية، وإصدار التصاريح البيئية للمشروعات التنمويَّة، وتنفيذ زيارات تفتيشية لمواقع المشروعات والمحميَّات.")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em"
    }
  }, [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("خبير مؤهَّل بالوقاية الإشعاعية \"")]), _vm._v("FANR-037QE"), _c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("\" بدولة الإمارات العربية المتحدة")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em"
    }
  }, [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("له اهتمامات بإلقاء المحاضرات بالوقاية الإشعاعية، واهتمامات بسلوك الأعداد، ومواهب شِعرية فردية، ومواهب بالرياضة والشطرنج.")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em"
    }
  }, [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("حصل على العديد مِن الجوائز، أهمُّها جائزة الدانة الذهبية - الفئة التخصُّصيَّة، ووسام الخدمة الطويلة مِن هيئة حكومية بإمارة أبوظبي، ودرع المجلس الأعلى للأمن الوطني.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0bccb5d1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch002.vue
// module id = 63
// module chunks = 0